import { render } from "./SaveBar.vue?vue&type=template&id=171e19f6&scoped=true"
import script from "./SaveBar.vue?vue&type=script&lang=js"
export * from "./SaveBar.vue?vue&type=script&lang=js"

import "./SaveBar.vue?vue&type=style&index=0&id=171e19f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-171e19f6"]])

export default __exports__

/* vue-cli-plugin-import-components */

import BackLink from "@/components/BackLink.vue";
import Button from "@/components/Button.vue";
script.components = Object.assign({}, { BackLink, Button }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { BackLink, Button }, script.__o.components);}